import { ValidatorFn, AbstractControl } from "@angular/forms";

export function passwordMatchValidator(newPasswordControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl) => {
        const newPassword = newPasswordControl.value;
        const confirmPassword = control.value;

        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
            return { passwordMismatch: true };
        }

        if (newPassword && !confirmPassword) {
            return { required: true };
        }

        return null;
    }
}
